import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Header } from "./header/Header";
import { Footer } from "./footer/Footer";
import "./App.css";
import { AuthProvider } from "./../context/AuthContext";
import { CartProvider } from "./../context/CartContext";
export const App = () => {
    return (_jsx(CartProvider, { children: _jsxs(AuthProvider, { children: [_jsxs("div", { className: "app-container", children: [_jsx(Header, {}), _jsx("main", { className: "main-content", children: _jsx(Outlet, {}) }), _jsx(Footer, {})] }), _jsx(ToastContainer, {})] }) }));
};
